import { antdMessageError } from "./Utils";

const errorHandler = (error) => {
  console.log("--Begin rror");
  console.error(error);
  console.error(error?.response?.data);
  antdMessageError(error?.message || error?.response?.data);
  console.log("--End rror");
};

export default errorHandler;
